export default __webpack_public_path__ + "static/media/caret.159b442c.svg";